import { makeStyles } from '@material-ui/core/styles'
import { Theme, Typography, Grid } from '@material-ui/core'
import { useFormikContext } from 'formik'
import { FormattedMessage } from 'react-intl'
import {
  SemiConfigFormValues,
  specificationItem,
  PhysicalMaterialTypes,
} from '../ProductsConfiguration'
import CustomCrisprRecommendationModal from '@src/routes/Configurators/components/PopUp/CustomCrisprRecommendationModal'
import SpecificationSelect from './SpecificationSelect'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    padding: theme.spacing(4, 0),
  },
  recommendation: {
    padding: theme.spacing(1, 0, 2),
  },
}))
interface PhysicalMaterialProps {
  physicalMaterialList: specificationItem[]
}

const PhysicalMaterial = ({ physicalMaterialList }: PhysicalMaterialProps) => {
  const classes = useStyles()
  const formik = useFormikContext<SemiConfigFormValues>()
  const onPhySicalMaterialChange = (
    e: React.ChangeEvent<{ value: unknown }>
  ) => {
    formik.setFieldValue(
      'specifications.physicalMaterial',
      e.target.value,
      false
    )
  }
  return (
    <Grid container className={classes.container}>
      <Grid item xs={12}>
        <Typography variant="h3">
          *
          <FormattedMessage
            id="CONF_SPECIFICATION_PHYSICAL_MATERIAL"
            defaultMessage="Physical Material"
          />
        </Typography>
      </Grid>
      {formik.values.specifications.physicalMaterial ===
        PhysicalMaterialTypes.RNA && (
        <Grid item xs={12} className={classes.recommendation}>
          <CustomCrisprRecommendationModal />
        </Grid>
      )}
      <SpecificationSelect
        list={physicalMaterialList}
        specificationLabel={
          <FormattedMessage
            id="CONF_SPECIFICATION_PHYSICAL_MATERIAL"
            defaultMessage="Physical Material"
          />
        }
        specificationValue={formik.values.specifications.physicalMaterial}
        handleChange={onPhySicalMaterialChange}
      />
    </Grid>
  )
}

export default PhysicalMaterial
